import styled, { css } from "styled-components";

interface UserHealthInfoStyleProps {
  $photoData?: boolean;
  $healthData?: boolean;
  $studentData?: boolean;
}

export const UserHealthInfo = styled.div<UserHealthInfoStyleProps>`
  gap: 12px;
  flex-direction: column;

  ${(props) =>
    props.$studentData === true &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.$photoData === false &&
    props.$healthData === false &&
    css`
      flex: 1;
      height: 100%;
    `}
`;

export const UserHealthTit = styled.h3`
  color: ${(props) => props.theme.colors.text4};
  font-size: 1.8rem;
  font-weight: 600;
`;

export const UserHealthData = styled.div<UserHealthInfoStyleProps>`
  gap: 24px;
  padding: 24px;
  box-shadow: ${(props) => props.theme.shadows.box};
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  box-sizing: border-box;

  ${(props) =>
    props.$studentData === true &&
    css`
      display: flex;
      flex-direction: column;
    `}

  ${(props) =>
    props.$photoData === false &&
    props.$healthData === false &&
    css`
      flex: 1;
    `}

  ${(props) =>
    props.$studentData === true
      ? css`
          height: 100%;
        `
      : css`
          height: 20vh;
        `}
`;

export const UserHealthChartBox = styled.div`
  gap: 24px;
  display: flex;
`;
